import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import axios from "../utils/server";
Vue.use(VueRouter);
//页面文件引入
import chargingList from "../pages/chargingList.vue";
import newsShare from "../pages/newsShare.vue";// 新闻分享
import news from "../pages/news.vue"; // 新闻详情
import DmklUpdata from "../pages/DmklUpdata.vue"; // 大美开滦
import newsNostyle from "../pages/newsNostyle.vue"; // 新闻详情(固定样式)

import picShare from "../pages/picShare.vue"; // 图片分享
import newsShareNostyle from "../pages/newsShareNostyle.vue"; // 新闻分享(固定样式)
import videoShare from "../pages/videoShare.vue"; // 视频分享
import invitation from "../pages/invitation.vue";
import liveShare from "../pages/liveShare.vue"; // 直播分享
import factShare from "../pages/factShare.vue";
import invoiceAdd from "../pages/invoiceAdd.vue";
import invoiceSelect from "../pages/invoiceSelect.vue";
import activityLive2 from "../pages/activityLive2.vue";
import newsDetail from "../pages/newsDetail.vue";
import goldList from "../pages/goldList.vue";
import Sports from "../pages/Sports.vue";
import SportsPLUS from "../pages/SportsPLUS.vue";
import masonryVIP from "../pages/masonryVIP.vue";
import audioShare from "../pages/audioShare.vue";  // 音频分享
// import newSharecss from "../pages/newSharecss.vue";
import epidemicSituation from "../pages/epidemicSituation.vue";
import newSpecial from "../pages/special/newSpecial.vue";
import peopleSpecial from "../pages/special/peopleSpecial.vue";
import preview from "../pages/preview.vue";

//路由配置audioShare
const constantRoutes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/Map",
    name: "Map",
    component: () => import("../views/Map.vue"),
  },
  {
    path: "/tv",
    name: "tv",
    component: () => import("../views/Tv.vue"),
  },
  {
    path: "/audio",
    name: "audio",
    component: () => import("../views/Audio.vue"),
  },
  {
    path: "/channelDetail",
    name: "channelDetail",
    component: () => import("../views/channelDetail"),
  },{
    path: "/epidemicSituation",
    name: 'epidemicSituation',
    component: epidemicSituation,
    meta: {
      title: "疫情防控",
    },
  }, {
    path: "/audioShare",
    name: 'audioShare',
    component: audioShare,
    meta: {
      title: "音频分享页",
    },
  }, {
    path: "/masonryVIP",
    name: 'masonryVIP',
    component: masonryVIP,
    meta: {
      title: "钻石会员",
    },
  }, {
    path: "/SportsPLUS",
    name: 'SportsPLUS',
    component: SportsPLUS,
    meta: {
      title: "PLUS会员",
    },
  }, {
    path: "/Sports",
    name: 'Sports',
    component: Sports,
    meta: {
      title: "VIP会员",
    },
  }, {
    path: "/goldList",
    name: 'goldList',
    component: goldList,
    meta: {
      title: "黄金会员",
    },
  }, {
    path: "/newsDetail",
    name: 'newsDetail',
    component: newsDetail,
    meta: {
      title: "新闻详情",
    },
  }, {
    path: "/chargingList",
    component: chargingList,
    meta: {
      title: "白金会员",
    },
  }, {
    path: "/invoiceAdd",
    component: invoiceAdd,
    meta: {
      title: "发票录入",
    },
  },
  {
    path: "/invoiceSelect",
    component: invoiceSelect,
    meta: {
      title: "中奖查询",
    },
  },
  {
    path: "/newsShare",
    component: newsShare,
    meta: {
      title: "新闻分享",
    },
  },
  {
    path: "/news",
    component: news,
    meta: {
      title: "新闻详情",
    },
  },
  {
    path: "/dmklupdata",
    component: DmklUpdata,
    meta: {
      title: "大美开滦",
    },
  },
  {
    path: "/newsNoStyle",
    component: newsNostyle,
    meta: {
      title: "新闻详情",
    },
  },
  {
    path: "/newsShareNoStyle",
    component: newsShareNostyle,
    meta: {
      title: "新闻分享",
    },
  },
  {
    path: "/picShare",
    component: picShare,
    meta: {
      title: "图集分享",
    },
  },

  {
    path: "/videoShare",
    component: videoShare,
    meta: {
      title: "视频分享",
    },
  },
  {
    path: "/invitation",
    component: invitation,
    meta: {
      title: "好友邀请",
    },
  },
  {
    path: "/liveShare",
    component: liveShare,
    meta: {
      title: "直播分享",
    },
  },
  {
    path: "/activitylive2",
    component: activityLive2,
    meta: {
      title: "直播分享",
    },
  },
  {
    path: "/factShare",
    component: factShare,
    meta: {
      title: "爆料分享",
    },
  },
  {
    path: "/newSpecial",
    component: newSpecial,
    meta: {
      title: "新闻专题",
    },
  },
  {
    path: "/peopleSpecial",
    component: peopleSpecial,
    meta: {
      title: "人物专题",
    },
  },
  {
    path: "/preview",
    component: preview,
    meta: {
      title: "预览",
    },
  },
];
const router = new VueRouter({
  mode: "history",
  routes: constantRoutes,
  base: process.env.BASE_URL,
});
router.beforeEach((to, from, next) => {
  store.commit("setLoading", true);
  //获取配置信息
  if (store.state.config == null) {
    axios.get("/wx/config").then(({ data }) => {
      store.commit("setLoading", false);
      if (data.status == 0) {
        store.commit("setConfig", data.data);
        if (
          data.data.domainPath == "" ||
          data.data.timAppId == "" ||
          data.data.timAppKey == "" ||
          data.data.weChatAppId == ""
        ) {
          //缺失参数
          Toast.fail("缺少必要参数,请联系管理员");
          next();
        } else {
          next();
        }
      }
    });
  } else {
    store.commit("setLoading", false);
    next();
  }
});
//修改title
// router.beforeEach((to, from, next) => {
//     document.title = to.meta.title;
//     next();
// });
export default router;